module.exports = __webpack_public_path__ + "static/media/1 color realism tattoo darth vader samurai japanese tattoo temple lightsaber.1280x1707.ea088839.webp";